// Mirror specific imports
import MirrorSettings from 'components/mirror/mirror-settings.vue';
import MirrorParticipantList from 'components/mirror/mirror-participant-list.vue';
import MirrorParticipant from 'components/mirror/mirror-participant.vue';
import MirrorHost from 'components/mirror/mirror-host.vue';
import MirrorSetupPage from 'components/mirror/mirror-setup-page.vue';
import MirrorMobileDrawer from 'components/mirror/mirror-mobile-drawer.vue';
import MirrorShootingPlan from 'components/mirror/mirror-shooting-plan.vue';
import VideoTakesList from 'components/mirror/video-takes-list.vue';
import ShootingBoard from 'components/shooting-board.vue';

import Stills from 'components/mirror/stills.vue';
import Continuity from 'components/mirror/continuity.vue';
import PushToTalk from 'components/push-to-talk.vue';


// Mirror specific
export default function registerComponents(Vue) {
    Vue.component('mirror-settings', MirrorSettings);
    Vue.component('mirror-participant-list', MirrorParticipantList);
    Vue.component('mirror-participant', MirrorParticipant);
    Vue.component('shooting-board', ShootingBoard);
    Vue.component('mirror-mobile-drawer', MirrorMobileDrawer);
    Vue.component('mirror-shooting-plan', MirrorShootingPlan);
    Vue.component('mirror-setup-page', MirrorSetupPage);
    Vue.component('stills', Stills);
    Vue.component('video-take-list', VideoTakesList);
    Vue.component('mirror-host', MirrorHost);
    Vue.component('continuity', Continuity);
    Vue.component('push-to-talk', PushToTalk);
}